import { Button, Form, Modal, Popconfirm, Select, Space, Table, Tabs, Tag } from 'antd';
import SocialAccountLoginButton from '../SocialAccountLoginButton';

const AgentBindModal = ({
  agentBindTarget,
  agentBindVisible,
  closeAgentBindModal,
  agentSettingsActiveTab,
  setAgentSettingsActiveTab,
  agentBindSubmitting,
  loadAgents,
  agentsLoading,
  loadAgentBindings,
  bindingsLoading,
  bindingItems,
  bindingPrimaryAgentId,
  handleCreateBinding,
  handleDeleteBinding,
  handleSetPrimaryBinding,
  handleAgentUnbind,
  agentBindForm,
  normalizeOptionalString,
  formatDateTime,
  agentSelectOptions,
  sessionLoginAgentId,
  setSessionLoginAgentId,
  operatorId,
  onLoginSuccess,
}) => (
  <Modal
    title={agentBindTarget ? `Agent设置 · ${agentBindTarget.account_name || agentBindTarget.account_id}` : 'Agent设置'}
    open={agentBindVisible}
    onCancel={closeAgentBindModal}
    confirmLoading={agentBindSubmitting || bindingsLoading}
    cancelText="关闭"
    destroyOnHidden
    footer={(
      <Button key="cancel" onClick={closeAgentBindModal} disabled={agentBindSubmitting || bindingsLoading}>
        关闭
      </Button>
    )}
    width={960}
  >
    <Tabs
      activeKey={agentSettingsActiveTab}
      onChange={setAgentSettingsActiveTab}
      items={[
        {
          key: 'binding',
          label: '默认Agent',
          children: (
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <div style={{ color: '#666' }}>
                账号ID：{agentBindTarget?.account_id || '-'}
              </div>
              <div style={{ color: '#666' }}>
                当前默认 Agent：{normalizeOptionalString(bindingPrimaryAgentId || agentBindTarget?.primary_agent_id || agentBindTarget?.agent_id) || '-'}
              </div>
              <Form form={agentBindForm} layout="vertical">
                <Space align="end" size={8} wrap style={{ width: '100%' }}>
                  <Form.Item
                    label="选择 Agent"
                    name="agent_id"
                    rules={[{ required: true, message: '请选择一个 Agent' }]}
                    style={{ minWidth: 320, marginBottom: 8, flex: 1 }}
                  >
                    <Select
                      showSearch
                      allowClear
                      loading={agentsLoading}
                      placeholder={agentsLoading ? '正在加载 Agent 列表...' : '请选择一个 Agent'}
                      options={agentSelectOptions}
                      optionFilterProp="label"
                      notFoundContent={agentsLoading ? '加载中...' : '暂无可用 Agent'}
                    />
                  </Form.Item>
                  <Button
                    onClick={() => loadAgents({ silent: false })}
                    loading={agentsLoading || agentBindSubmitting}
                    style={{ marginBottom: 8 }}
                  >
                    刷新 Agent
                  </Button>
                  <Button
                    type="primary"
                    onClick={handleCreateBinding}
                    loading={agentBindSubmitting}
                    style={{ marginBottom: 8 }}
                  >
                    绑定/换绑
                  </Button>
                  <Button
                    danger
                    onClick={() => handleAgentUnbind(agentBindTarget)}
                    disabled={!normalizeOptionalString(bindingPrimaryAgentId || agentBindTarget?.primary_agent_id || agentBindTarget?.agent_id)}
                    loading={agentBindSubmitting}
                    style={{ marginBottom: 8 }}
                  >
                    解绑
                  </Button>
                </Space>
              </Form>
              <div style={{ color: '#999', fontSize: 12 }}>
                默认 Agent 决定该账号的常规执行路径（如定时任务）；手动接管可在发布流程中按次指定。
              </div>
            </Space>
          ),
        },
        {
          key: 'sessions',
          label: '设备会话',
          children: (
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Space>
                <Button onClick={() => loadAgentBindings({ silent: false })} loading={bindingsLoading || agentBindSubmitting}>
                  刷新会话
                </Button>
              </Space>
              <Table
                size="small"
                rowKey={(row) => row.binding_id || row.agent_id}
                loading={bindingsLoading}
                pagination={false}
                dataSource={Array.isArray(bindingItems) ? bindingItems : []}
                locale={{ emptyText: '暂无设备会话，先绑定默认 Agent 并执行一次登录' }}
                columns={[
                  {
                    title: 'Agent',
                    key: 'agent',
                    width: 280,
                    render: (_, row) => {
                      const agentId = normalizeOptionalString(row?.agent_id) || '-';
                      return (
                        <div style={{ lineHeight: 1.4 }}>
                          <div style={{ wordBreak: 'break-all' }}>{row?.hostname || agentId}</div>
                          <div style={{ color: '#999', fontSize: 12 }}>{agentId}</div>
                          <Tag color={row?.is_online ? 'green' : 'default'} style={{ marginTop: 4 }}>
                            {row?.is_online ? '在线' : '离线'}
                          </Tag>
                        </div>
                      );
                    },
                  },
                  {
                    title: '平台',
                    key: 'platform',
                    width: 120,
                    render: () => agentBindTarget?.platform_code || agentBindTarget?.platform || '-',
                  },
                  {
                    title: '绑定角色',
                    dataIndex: 'role',
                    key: 'role',
                    width: 120,
                    render: (value) => (value === 'primary' ? <Tag color="blue">主绑定</Tag> : <Tag>备用</Tag>),
                  },
                  {
                    title: '优先级',
                    dataIndex: 'priority',
                    key: 'priority',
                    width: 100,
                    render: (value) => Number(value || 100),
                  },
                  {
                    title: '启用',
                    key: 'enabled',
                    width: 90,
                    render: (_, row) => <Tag color={row?.enabled ? 'green' : 'default'}>{row?.enabled ? '启用' : '禁用'}</Tag>,
                  },
                  {
                    title: '更新时间',
                    dataIndex: 'updated_at',
                    key: 'updated_at',
                    width: 180,
                    render: (value) => formatDateTime(value),
                  },
                  {
                    title: '操作',
                    key: 'actions',
                    width: 220,
                    render: (_, row) => (
                      <Space size={8}>
                        {normalizeOptionalString(row?.agent_id) !== normalizeOptionalString(bindingPrimaryAgentId) ? (
                          <Button size="small" onClick={() => handleSetPrimaryBinding(row)}>
                            设为主绑定
                          </Button>
                        ) : (
                          <Tag color="blue">主绑定</Tag>
                        )}
                        <Popconfirm
                          title="确认删除该绑定？"
                          okText="删除"
                          cancelText="取消"
                          onConfirm={() => handleDeleteBinding(row)}
                        >
                          <Button size="small" danger>删除</Button>
                        </Popconfirm>
                      </Space>
                    ),
                  },
                ]}
                scroll={{ x: 1100 }}
              />
            </Space>
          ),
        },
        {
          key: 'login',
          label: '指定Agent登录',
          children: (
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <div style={{ color: '#666' }}>
                为当前账号选择一台 Agent 执行登录，不会强制改变默认 Agent 绑定。
              </div>
              <Space align="start" style={{ width: '100%' }}>
                <Select
                  showSearch
                  allowClear
                  style={{ minWidth: 320 }}
                  placeholder="选择要登录的 Agent（可选）"
                  value={sessionLoginAgentId || undefined}
                  options={agentSelectOptions}
                  loading={agentsLoading}
                  onChange={(value) => setSessionLoginAgentId(normalizeOptionalString(value) || '')}
                  onOpenChange={(open) => {
                    if (open) loadAgents({ silent: true });
                  }}
                />
                <SocialAccountLoginButton
                  key={`session-login-${agentBindTarget?.account_id || 'na'}-${sessionLoginAgentId || 'default'}`}
                  account={agentBindTarget || {}}
                  agentId={sessionLoginAgentId}
                  operatorId={operatorId}
                  label="在该 Agent 登录"
                  disabled={!agentBindTarget?.account_id}
                  onSuccess={onLoginSuccess}
                />
              </Space>
            </Space>
          ),
        },
      ]}
    />
  </Modal>
);

export default AgentBindModal;
